import { Box, Button, IconButton, Switch, Typography } from "@mui/material";
import AppBarContainer from "../../../components/shared/AppBarContainer";
import PageContentContainer from "../../../components/shared/PageContentContainer";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import BottomFullWidthButtonContainer from "../../../components/shared/BottomFullWidthButtonContainer";
import { ReactComponent as SettingIcon } from "../../../assets/icons/setting-colored.svg";
import AutoInvestmentFundStatusCard from "../../../components/auto-investment/AutoInvestmentFundStatusCard";
import { AutoInvestmentStatusBottomSheet } from "../../../components/auto-investment/AutoInvestMentStatusBottomSheet";
import CustomRectangularSkeleton from "../../../components/shared/CustomRectangularSkeleton";
import InfoBox from "../../../components/shared/InfoBox";
import { useRequest } from "../../../api/utils/useRequest";
import { BalootUserAPIs } from "../../../api/APIs";
import { useSnackBar } from "../../../context/SnackBarContext";
import { useDispatch, useSelector } from "react-redux";
import { setConfig } from "../../../store/actions/ConfigActions";

function AutoInvestmentActivatePage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { config } = useSelector((state) => state.config);
  const openSnack = useSnackBar();
  const {
    autoInvestmentStatus,
    setAutoInvestmentStatus,
    statusLoading,
    fundsLoading,
    fundsResult,
    statusResult,
  } = useOutletContext();

  const { loading: stateLoading, apiCall: setAutoInvestmentState } = useRequest(
    BalootUserAPIs.setAutoInvestmentState
  );

  const [switchChecked, setSwitchChecked] = useState(false);

  const handleSwitchOn = () => {
    setSwitchChecked(true);
    setAutoInvestmentState({
      data: { enabled: true },
      onSuccess: () => {
        //update config state to show status on gholak
        dispatch(
          setConfig({
            config: {
              ...config,
              profile: {
                ...config.profile,
                hasAutoInvestment: true,
              },
            },
          })
        );
        setAutoInvestmentStatus((prev) => {
          return { ...prev, enabled: true };
        });
        navigate("add-or-remove", {
          state: { fromContainer: true },
          replace: true,
        });
      },
      onError: (error) => {
        setSwitchChecked(false);
        openSnack(true, { message: error.message });
      },
    });
  };

  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton onClick={() => navigate(-1)}>
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            سرمایه‌گذاری خودکار
          </Typography>
        }
      />
      <PageContentContainer sx={{ overflow: "auto", display: "block" }}>
        {fundsLoading || statusLoading ? (
          <>
            <CustomRectangularSkeleton sx={{ mt: 2 }} height={80} />
            <CustomRectangularSkeleton sx={{ mt: 2 }} height={80} />
            <CustomRectangularSkeleton sx={{ mt: 2 }} height={80} />
            <CustomRectangularSkeleton sx={{ mt: 2 }} height={80} />
          </>
        ) : (
          <>
            {fundsResult && statusResult && (
              <>
                <Box
                  sx={{
                    mb: "24px",
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="body2" color="grey.2">
                    فعال سازی سرمایه‌گذاری خودکار
                  </Typography>
                  <Switch
                    checked={switchChecked}
                    onChange={(event) => {
                      handleSwitchOn();
                    }}
                  />
                </Box>
                {stateLoading ? (
                  <>
                    <CustomRectangularSkeleton sx={{ mt: 2 }} height={80} />
                    <CustomRectangularSkeleton sx={{ mt: 2 }} height={80} />
                    <CustomRectangularSkeleton sx={{ mt: 2 }} height={80} />
                    <CustomRectangularSkeleton sx={{ mt: 2 }} height={80} />
                  </>
                ) : (
                  <InfoBox
                    title="چرا سرمایه‌گذاری خودکار؟"
                    description={
                      <>
                        «سرمایه‌گذاری خودکار» دردسر و فراموشی خرید صندوق‌ها را
                        از بین می‌برد <br /> در این حالت بعد از اینکه موجودی قلک
                        شما به اندازه قیمت یک صندوق سرمایه‌گذاری شد، بلوط به
                        صورت خودکار صندوق مورد نظر را خریداری می‌کند.
                      </>
                    }
                  />
                )}
              </>
            )}
          </>
        )}
      </PageContentContainer>
    </>
  );
}

export default AutoInvestmentActivatePage;
